import { Controller, useFormContext } from "react-hook-form";
import { View } from "react-native-ui-lib";
import { Label, TextField } from "@towersystems/roam-common-native";
import { useTranslation } from "react-i18next";
import { DocketTemplateFormValues } from "../types";

export interface NameInputFieldProps {}

export const NameInputField = (props: NameInputFieldProps) => {
  const { t } = useTranslation("settings");
  const { control } = useFormContext<DocketTemplateFormValues>();
  return (
    <View>
      <Label required label={t("form.docket_template_name.label")}></Label>
      <Controller
        name="name"
        control={control}
        render={({
          field: { onChange, value, onBlur },
          fieldState: { error },
        }) => (
          <TextField
            onBlur={onBlur}
            value={value ?? ""}
            onChangeText={onChange}
            validationMessage={error ? error.message : undefined}
            placeholder={t("form.docket_template_name.placeholder")}
          />
        )}
      />
    </View>
  );
};
